import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from "@chakra-ui/react";

const SwaggerPage = () => {
  return (
    <Box h="100vh" w="100%">
      <Tabs>
        <TabList>
          <Tab>Newton Docs</Tab>
          <Tab>Darwin Docs</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            {/* Newton iframe */}
            <iframe
              src={process.env.REACT_APP_SWAGGER_NEWTON}
              width="100%"
              height="800px"
              style={{ border: "none" }}
              title="Newton Swagger"
            />
          </TabPanel>
          <TabPanel>
            {/* Darwin iframe */}
            <iframe
              src={process.env.REACT_APP_SWAGGER_DARWIN}
              width="100%"
              height="800px"
              style={{ border: "none" }}
              title="Darwin Swagger"
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default SwaggerPage;
